import { ListItemButton } from '@mui/material'
import React from 'react'
import { OrganizationTableItem } from 'types/organizations_table'
import ProductItem from './ProductItem'
const ProductItemList = ({
  props,
  option,
}: {
  props: React.HTMLAttributes<HTMLLIElement>
  option: OrganizationTableItem
}) => {
  return (
    <li {...props} key={option.SK || option.uuid || option.id} style={{ padding: 1 }}>
      <ListItemButton dense sx={{ px: 1.25, py: 0.75 }}>
        <ProductItem option={option} />
      </ListItemButton>
    </li>
  )
}

export default ProductItemList
